var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.39994 1.33347c-.04371.21536-.06665.43825-.06665.6665 0 1.84095 1.49241 3.33334 3.33331 3.33334.2283 0 .4513-.02296.6667-.06668v9.38987h-1l-4.33334-2.6666-4.33333 2.6666h-1V5.33347c0-1.24251 0-1.86377.20298-2.35382.27065-.65341.78978-1.17254 1.44319-1.44319.49006-.20299 1.11132-.20299 2.35383-.20299h2.73331Z",
    fill: "var(--color-invert)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.3333 4.33331 2.8047-2.80473-.9428-.942814L12.3333 2.4477l-.8619-.86193-.9428.94281 1.8047 1.80473Z",
    fill: "var(--color-invert)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkCheck);
export default __webpack_public_path__ + "static/media/bookmarkCheck.19c1ff39c967852f04c1bbac0ba85af0.svg";
export { ForwardRef as ReactComponent };